import React from "react";

const Toast = ({ toast, onDismiss }) => {
  const getToastStyles = (type) => {
    const baseStyles = {
      position: "relative",
      maxWidth: "300px",
      padding: "12px 16px",
      borderRadius: "6px",
      color: "white",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      fontSize: "14px",
      textAlign: "center",
    };

    return {
      ...baseStyles,
      backgroundColor: "#5d6672",
    };
  };

  const getIcon = (type) => {
    const icons = {
      info: "ℹ️",
      success: "✅",
      warning: "⚠️",
      error: "❌",
    };
    return icons[type] || icons.info;
  };

  return (
    <div style={getToastStyles(toast.type)}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          marginBottom: toast.dismissible ? "12px" : "0",
        }}
      >
        <span style={{ fontSize: "14px" }}>{getIcon(toast.type)}</span>
        <span>{toast.message}</span>
      </div>

      {toast.dismissible && (
        <button
          onClick={() => onDismiss(toast.id)}
          className="btn btn-primary"
          style={{
            backgroundColor: "#007bff",
            borderColor: "#007bff",
            color: "white",
            padding: "4px 12px",
            borderRadius: "4px",
            fontSize: "12px",
            fontWeight: "400",
            lineHeight: "1.5",
            cursor: "pointer",
            transition: "all 0.15s ease-in-out",
          }}
        >
          OK
        </button>
      )}
    </div>
  );
};

export default Toast;
